import React from 'react';
import VstComponent from './VstComponent';

class VstTableCell extends VstComponent {

  render() {
    return (
      <td>
        {this.props.children}
      </td>
    );
  }
}

export default VstTableCell;
